export default {
  getFormFields1: (state) => state.formFields1,
  getFormFields2: (state) => state.formFields2,
  getLastAction: (state) => state.lastAction,
  getPreventCopy: (state) => state.preventCopy,
  getSelectedFieldIndex: (state) => state.selectedFieldIndex,
};
